import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles';

import Field from '../FormField';
import DateTimeInput from '../DateTimeInput';
import RadioGroup from '../RadioGroup';
import Label from '../Label';
import { formMessages as messages } from '../../defineMessages';

import s from './DateTimeOptions.scss';
import { ICONS } from '../../constants';
import { isDateInPast } from '../../helpers/date';

const DATE_FIELD_NAME = 'deliveryDate';
const OPTIONS_FIELD_NAME = 'deliveryDateOption';
const DATE_OPTIONS = {
  asap: 'asap',
  custom: 'custom',
};

const DateTimeOptions = ({ initialValue, onChange }) => {
  const initialState = initialValue ? !isDateInPast(initialValue) : false;
  const [showDateInput, setShowDateInput] = useState(initialState);
  const { formatMessage, locale } = useIntl();

  const toggleShowDate = () => setShowDateInput(!showDateInput);

  const dateOptions = [
    {
      value: DATE_OPTIONS.asap,
      label: formatMessage({ ...messages.date_asap }),
      isSelected: !showDateInput,
      icon: ICONS.FAST_DELIVERY,
      iconSize: 24,
      onChange: () => {
        setShowDateInput(!showDateInput);
      },
    },
    {
      value: DATE_OPTIONS.custom,
      label: formatMessage({ ...messages.set_date }),
      isSelected: showDateInput,
      icon: ICONS.CLOCK,
      onChange: () => toggleShowDate(),
    },
  ];
  return (
    <>
      <Label tag="h3" bold className={s.formLabel}>
        {formatMessage({ ...messages.date })}
      </Label>
      <div className={s.datefield}>
        <Field
          input={RadioGroup}
          name={OPTIONS_FIELD_NAME}
          radioProps={dateOptions}
          fluid
        />
      </div>
      <p>
        {showDateInput
          ? formatMessage({
              ...messages.set_delivery_date_disclaimer,
            })
          : formatMessage({
              ...messages.asap_delivery_date_disclaimer,
            })}
      </p>
      {showDateInput ? (
        <Field
          input={DateTimeInput}
          initialValue={initialValue}
          name={DATE_FIELD_NAME}
          fluid
          showLabel
          required
          autoComplete={false}
          locale={locale}
          onChange={onChange}
        />
      ) : null}
    </>
  );
};

DateTimeOptions.propTypes = {
  initialValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

DateTimeOptions.defaultProps = {
  initialValue: null,
};

export default compose(withStyles(s))(DateTimeOptions);
